module.exports = __webpack_public_path__ + "img/logo.6bfaf0c8.svg";